import { QuebecOption } from '~src/domains/common/enums/common';
import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';
import { StartOption } from '../enums/start';
import { createAction, createReducer } from '@reduxjs/toolkit';

export type StartLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [StartOption.FIRST_NAME],
  [StartOption.LAST_NAME],
  [StartOption.ADDRESS],
  [StartOption.CITY],
  [StartOption.REGION],
  [StartOption.POSTAL_CODE],
  [StartOption.DATE_OF_BIRTH],
  [StartOption.INCOME],
  [StartOption.SSN],
  [StartOption.EMAIL],
  [StartOption.MOBILE],
  [QuebecOption.MONTHLY_HOUSING_COST],
  [QuebecOption.PRIMARY_INCOME_SOURCE],
  [QuebecOption.OCCUPATION],
  [QuebecOption.EMPLOYMENT_DURATION],
]);

export const startFormSlice: any = createFormMetaSlice(
  'startForm',
  formMetaDefault,
  {
    updateMultipleInputsHidden: (state: any, action: any) => {
      const forcedOptions = action.payload.inputs;

      for (let i = 0; i < forcedOptions.length; i++) {
        const forcedOption = forcedOptions[i];
        state[forcedOption.name].isHidden = forcedOption.value;
      }
    },
    updateMultipleInputsDisabled: (state: any, action: any) => {
      const forcedOptions = action.payload.inputs;

      for (let i = 0; i < forcedOptions.length; i++) {
        const forcedOption = forcedOptions[i];
        state[forcedOption.name].isDisabled = forcedOption.value;
      }
    },
    updateMultipleInputsValue: (state: any, action: any) => {
      const forcedOptions = action.payload.inputs;

      for (let i = 0; i < forcedOptions.length; i++) {
        const forcedOption = forcedOptions[i];
        state[forcedOption.name].value = forcedOption.value;
      }
    },
  },
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
  updateInputDisabled,
  updateMultipleInputsHidden,
  updateMultipleInputsValue,
  updateMultipleInputsDisabled,
} = startFormSlice.actions;

export default startFormSlice.reducer;
